<script>
import { statusMap } from "./data";

export default {
    name: "TableList",
    props: {
        tableData: {
            type: Array,
            default: () => []
        }
    },
    methods: {

        /**
         * 合并单元格句柄方法
         */
        handleSpanMethod(
            {
                row, // 行
                column, // 列
                rowIndex, // 行索引
                columnIndex // 列索引
            }
        ) {
            if ([0, 1, 2].includes(columnIndex)) {
                // 获取当前单元格的值
                const currentValue = row[column.property];

                // 获取上一行相同列的值
                const preRow = this.tableData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;

                // 如果当前值和上一行的值相同，则将当前单元格隐藏
                if (currentValue === preValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    // 否则计算当前单元格应该跨越多少行
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.tableData.length; i++) {
                        const nextRow = this.tableData[i];
                        const nextValue = nextRow[column.property];
                        if (nextValue === currentValue) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return { rowspan, colspan: 1 };
                }
            }
        },
        formatDate(date) {
            if (date === "0") return "-"
            return `${date.slice(0,4)}.${date.slice(4,6)}.${date.slice(6,8)}`
        },
        formatStatus(status) {
            return statusMap[status]
        }
    }
}
</script>

<template>
    <el-table
        :span-method="handleSpanMethod"
        :data="tableData"
        border
        style="width: 100%"
    >
        <el-table-column
            :show-overflow-tooltip="true"
            label="公司名称"
            prop="company"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            label="预警风险大类"
            width="120"
            prop="type"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            label="预警风险名称"
            prop="risk"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            label="预警KRI名称"
            prop="kri"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            label="风险负责部门"
            prop="风险负责部门"
            width="120"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            label="预计完成时间"
            prop="预计完成时间"
            width="120"
        >
            <template slot-scope="scope">
                {{ formatDate(scope.row["预计完成时间"]) }}
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            label="当前预警状态"
            width="120"
        >
            <template slot-scope="scope">
                {{ formatStatus(scope.row["当前预警状态"]) }}
            </template>
        </el-table-column>
    </el-table>
</template>

<style scoped lang="less">

</style>